module.exports = __webpack_public_path__ + "img/flight+hotel.6fda1837.svg";